import qs from 'qs';

export const qsStringify = (obj: unknown) =>
  qs.stringify(obj, { arrayFormat: 'repeat' });

export const qsParse = (str: string) =>
  qs.parse(str, { ignoreQueryPrefix: true });
